import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface NavItem {
  text: string;
  logo: React.ReactNode;
  link?: string;
  onClick?: () => void;
}

interface LeftBarPutTopProps {
  items: NavItem[];
  hide?: boolean;
}

const LeftBarPutTop: React.FC<LeftBarPutTopProps> = ( { items, hide = false } ) => {
  const navigate = useNavigate();
  const [ hoveredItem, setHoveredItem ] = useState<string | null>( null );
  const [ isMenuHover, setIsMenuHover ] = useState<boolean>( false );

  const handleNavigation = ( link: string ) => {
    navigate( link );
  };

  return (
    <div className={`fixed top-0 left-0 w-full z-30 shadow-md ${hide ? 'hidden' : 'flex'}`}>
      <div
        className='w-full flex flex-col z-30 relative'
        onMouseEnter={() => {return setIsMenuHover( true );}}
        onMouseLeave={() => {return setIsMenuHover( false );}}
      >
        <div className='flex items-center justify-evenly bg-white dark:bg-dark-bg2 border-b dark:border-dark-bg-light text-orange-base w-full z-[29]'>
          {items.map( ( item, index ) => {return (
            <button
              key={index}
              className={`pt-3 px-4 flex flex-col items-center relative group ${
                hoveredItem === item.text ? 'text-orange-500' : ''
              }`}
              onClick={() => {
                if ( item.link ) {
                  handleNavigation( item.link );
                } else if ( item.onClick ) {
                  item.onClick();
                }
              }}
              onMouseEnter={() => {return setHoveredItem( item.text );}}
              onMouseLeave={() => {return setHoveredItem( null );}}
            >
              <div className='flex justify-center items-center mb-1'>{item.logo}</div>
              <span className='text-sm font-medium text-white'>{item.text}</span>
              <div
                className={`w-10 h-1 mt-1 absolute bottom-2 rounded-full transition-all duration-300 ${
                  hoveredItem === item.text ? 'bg-orange-base' : 'bg-transparent'
                }`}
              />
            </button>
          );} )}
        </div>

        <div
          className={`absolute flex justify-evenly text-base top-full w-full bg-gray-100 shadow-md shadow-gray-400 transition-all duration-400 ease-in-out overflow-hidden ${
            isMenuHover ? 'max-h-[400px]' : 'max-h-0 p-0'
          }`}
        >
          {items.map( ( item, index ) => {return (
            <button
              key={index}
              className='flex h-full py-2 items-center'
              onClick={() => {
                if ( item.link ) {
                  handleNavigation( item.link );
                } else if ( item.onClick ) {
                  item.onClick();
                }
              }}
              onMouseEnter={() => {return setHoveredItem( item.text );}}
              onMouseLeave={() => {return setHoveredItem( null );}}
            >
              <div
                className={`relative overflow-hidden ease-in-out duration-200 px-4 py-1.5 rounded-xl ${
                  hoveredItem === item.text ? 'text-white' : ''
                }`}
              >
                <span
                  className={`absolute inset-0 transition-transform duration-300 ease-in-out ${
                    hoveredItem === item.text
                      ? 'transform translate-y-0'
                      : 'transform -translate-y-full'
                  } bg-orange-base`}
                />
                <p className='z-10 relative'>{item.text}</p>
              </div>
            </button>
          );} )}
        </div>
      </div>
    </div>
  );
};

export default LeftBarPutTop;
